import { getFromStorage, saveInStorage } from "../util/Utility";
import SharedPreferences from "../constants/SharedPreferences";
import {
  getMemberClientData,
  setIsFRRegistered,
  createMemberAppForSSO,
  createMemberData,
} from "./BayunAPIManager";
import { AuthenticateResponse } from "../BayunCore";
import BayunError from "../constants/BayunError";

let sessionId;
let registerFlow;
let finalSuccessCallback;
let finalFailureCallback;
let FaceImage = null;
// let passcodeToSend = null;
// This is to initializeVishwamSDK
export const initializeVishwamSDK = (session) => {
  if (process.env.INCLUDE_VISHWAM == false) {
    return;
  }
  console.log("INIT vishwam = ", window.vishwamSDK);
  $(document).ready(function () {
    window.vishwamSDK.init();
    sessionId = session;
  });
};

// Capture face
export const faceCaptureRegisterAndLogin = async (
  register,
  successCallback,
  failureCallback,
) => {
  // removeLoadMask();
  if (document.querySelector(".loadmask-container")) {
    removeLoadMask();
  }
  registerFlow = register;
  finalSuccessCallback = successCallback;
  finalFailureCallback = failureCallback;
  let params = {
    isImageCapture: true,
    video_time: 10,
    shouldShowReviewScreen: false,
    showScreen: "captureFace",
    faceCaptureTitle: "Face Capture",
  };
  await window.vishwamSDK.captureFace(
    false,
    myCallBackFunctionFaceCapture,
    params,
  );
};

function myCallBackFunctionFaceCapture(response) {
  console.log(response);
  // addLoadMask();
  if (document.querySelector(".loadmask-container")) {
    addLoadMask();
  }
  if (response.success) {
    FaceImage = response.data.image;
    console.log("Face captured =", FaceImage);
    getAuthToken();
  }
  let element = document.getElementById("response-box");

  if (element) {
    element.textContent = JSON.stringify(response);
  }
}

// Get Auth Token
const getAuthToken = async () => {
  const userId = await getFromStorage(sessionId, SharedPreferences.USER_ID);
  console.log("userId = ", userId);
  let params = {
    app_id: "vishwam_bayun",
    expiry_at: "24h",
    app_key: "dmlzaHdhbV9iYXl1bg==",
    send_token: "1",
    user_id: userId,
    domain_url: "https://bayuns-stag.vishwamcorp.com",
  };
  window.vishwamSDK.getAuthToken(params, authTokenCallBack);
};

function authTokenCallBack(error, response) {
  if (error) {
    console.log("there is error in auth = ", error);
  } else {
    var AuthToken = response.token;
    // console.log("Auth Token = ", AuthToken);
    if (registerFlow == "true") {
      register(AuthToken);
    } else if (registerFlow == "false") {
      verification(AuthToken);
    }
  }
}

// Register
const register = async (AuthToken) => {
  const secret = await getFromStorage(
    sessionId,
    SharedPreferences.VISHWAM_SECRET,
  );
  const encryption_key = await getFromStorage(
    sessionId,
    SharedPreferences.FR_ENCRYPTION_KEY,
  );

  let params = {
    domain_url: "https://bayuns-stag.vishwamcorp.com",
    app_id: "vishwam_bayun",
    encryption_key: encryption_key,
    secret: secret,
    type: "0",
    deviceOs: "A",
    device_model: "samsung",
    skip_auth: "0",
    auth_token: AuthToken,
  };
  window.vishwamSDK.registerAPICall(FaceImage, params, registerAPICallBack);
};

async function registerAPICallBack(error, response) {
  if (error) {
    console.log("Error in register is = ", error);
    if (error.status == 424) {
      if (
        confirm("Please capture clear picture with proper light on the face") ==
        true
      ) {
        console.log("Call register again");
        await faceCaptureRegisterAndLogin(
          "true",
          finalSuccessCallback,
          finalFailureCallback,
        );
        return;
      } else {
        await setIsFRRegistered(sessionId, "false");
      }
    } else {
      alert("Face was not registred due to issue on server");
      await setIsFRRegistered(sessionId, "false");
    }
  } else if (response) {
    await setIsFRRegistered(sessionId, "true");
  }
  if (
    await getFromStorage(
      sessionId,
      SharedPreferences.IS_VALIDATE_2FA_FOR_CREATE_MEMBER_APP,
    )
  ) {
    finalFailureCallback(BayunError.ERROR_LINK_USER_MEMBER_ON_ADMIN);
    return;
  } else {
    finalSuccessCallback({
      sessionId,
      securityQuestions: null,
      authenticationResponse: AuthenticateResponse.SUCCESS,
    });
  }
}

// verify
const verification = async (AuthToken) => {
  const decryption_key = await getFromStorage(
    sessionId,
    SharedPreferences.FR_DECRYPTION_KEY,
  );
  let params = {
    domain_url: "https://bayuns-stag.vishwamcorp.com",
    decryption_key: decryption_key,
    app_id: "vishwam_bayun",
    n: "8",
    version: "1",
    deviceOs: "A",
    deviceModel: "samsung",
    request_id: "ed_sim",
    auth_token: AuthToken,
  };
  window.vishwamSDK.verificationAPICall(
    FaceImage,
    params,
    verificationAPICallBack,
  );
};

async function verificationAPICallBack(error, response) {
  if (error) {
    console.log("Error in veri is = ", error);
    alert(error.message);
    // removeLoadMask();
    if (document.querySelector(".loadmask-container")) {
      removeLoadMask();
    }
  } else {
    await saveInStorage(
      sessionId,
      SharedPreferences.VISHWAM_SECRET,
      response.data.secret,
    );

    // This will be called when new app comes and user exist.
    if (
      await getFromStorage(
        sessionId,
        SharedPreferences.IS_VALIDATE_2FA_FOR_CREATE_MEMBER_APP,
      )
    ) {
      await createMemberAppForSSO(
        sessionId,
        await getFromStorage(sessionId, SharedPreferences.ORG_NAME),
        await getFromStorage(sessionId, SharedPreferences.ORG_MEMBER_ID),
        null,
      );
    } else {
      await getMemberClientData(
        sessionId,
        await getFromStorage(sessionId, SharedPreferences.ORG_MEMBER_ID),
        await getFromStorage(sessionId, SharedPreferences.ORG_NAME),
        // passcodeToSend
        null,
        finalFailureCallback,
      );
    }
    // removeLoadMask();
    if (document.querySelector(".loadmask-container")) {
      removeLoadMask();
    }
    finalSuccessCallback({
      sessionId,
      securityQuestions: null,
      authenticationResponse: AuthenticateResponse.SUCCESS,
    });
  }
}

// export const setPasscode = (passcode) => {
//   passcodeToSend = passcode;
// };
